<template>
  <div :class="classes(n(), n(`--${background}`))">
    <div :class="classes(n('inner'))">
      <!-- 左/右始终渲染；量测后两侧同宽，保证标题几何居中 -->
      <div
        ref="leftRef"
        :class="classes(n('left'))"
        :style="sideStyle"
        :role="showLeft ? 'button' : undefined"
        aria-merge="true"
        aria-label="back"
        @click="onClickLeft"
      >
        <template v-if="showLeft">
          <slot
            v-if="$slots.left"
            name="left"
          />
          <ArrowLeftOIcon
            v-else
            width="24"
            height="48"
            :class="classes(n('left-icon'))"
          />
        </template>
      </div>

      <div :class="classes(n('center'))">
        <span :class="classes(n('title'))">{{ title }}</span>
      </div>

      <div
        ref="rightRef"
        :class="classes(n('right'))"
        :style="sideStyle"
        :role="showRight ? 'button' : undefined"
        aria-merge="true"
        @click="onClickRight"
      >
        <slot
          v-if="showRight"
          name="right"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'virtual-vue';
import { ArrowLeftOIcon } from '@tencent/wphk-design-icons';
import { props } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { useNavBarSideWidth } from './use-side-width';

const { name, n, classes } = createNamespace('nav-bar');

export default defineComponent({
  name,
  components: {
    ArrowLeftOIcon,
  },
  props,
  emits,
  setup(props, { emit }) {
    // 安全区（状态栏高度 / 刘海）由业务自行处理：组件不内置 paddingTop。
    // 标题居中：量测左右侧宽取 max 写回两侧（见 useNavBarSideWidth）。

    const leftRef = ref<HTMLElement | null>(null);
    const rightRef = ref<HTMLElement | null>(null);

    const { sideStyle } = useNavBarSideWidth({
      leftRef,
      rightRef,
      deps: () => [props.showLeft, props.showRight],
    });

    function onClickLeft(e: MouseEvent) {
      if (!props.showLeft) return;
      emit('click-left', e);
    }

    function onClickRight(e: MouseEvent) {
      if (!props.showRight) return;
      emit('click-right', e);
    }

    return {
      n,
      classes,
      leftRef,
      rightRef,
      sideStyle,
      onClickLeft,
      onClickRight,
    };
  },
});
</script>
